
/* eslint-disable no-unused-vars */
import comparisonApi from '@/services/comparisonApi'

const getComparison = async ({ commit }, comparisonId) => {
  try {
    const { data } = await comparisonApi.getOneComparison(comparisonId)
    commit('UPDATE_COMPARISON', data)
  } catch (e) {
    throw new Error(e)
  }
}

const updateComparison = async ({ commit }, [comparisonRequestObject, comparisonId]) => {
  try {
    const { data } = await comparisonApi.updateComparison(comparisonRequestObject, comparisonId)
    return data
  } catch(e) {
    throw new Error(e)
  }
}

const finishComparison = async ({ commit }, [comparisonId, winnerVideoId]) => {
  try {
    const { data } = await comparisonApi.finishComparison(comparisonId, winnerVideoId)
    commit('UPDATE_WINNER_VIDEO', winnerVideoId)
    commit('UPDATE_COMPARISON_STATUS', data.status)
    return data
  } catch(e) {
    throw new Error(e)
  }
}

const startComparison = async ({ commit }, comparisonId) => {
  try {
    const { data } = await comparisonApi.startComparison(comparisonId)
    commit('UPDATE_COMPARISON', data)
    return data
  } catch(e) {
    throw new Error(e)
  }
}

export {
  getComparison,
  updateComparison,
  finishComparison,
  startComparison
}